"use strict";
exports.__esModule = true;
exports.Media = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var media_style_1 = require("./media.style");
var Media = function (props) {
    var children = props.children, style = props.style, at = props.at, greaterThan = props.greaterThan, lessThan = props.lessThan, between = props.between, className = props.className;
    return (react_1["default"].createElement("div", { style: style, className: (0, class_names_1["default"])((0, media_style_1.STYLES)({ at: at, greaterThan: greaterThan, lessThan: lessThan, between: between }), className) }, children));
};
exports.Media = Media;
exports["default"] = exports.Media;
//# sourceMappingURL=media.js.map